export const queries = {
  identificationTypes: 'identificationTypes',
  genders: 'genders',
  timezone: 'timezone',
  specialties: 'specialties',
  userPaymentMethods: 'userPaymentMethods',
  paymentMethods: 'paymentMethods',
  bankTransferData: 'bankTransferData',
  amountTypes: 'amountTypes',
  userMeData: 'userMeData',
  myClinics: 'myClinics',
};
